import { render, staticRenderFns } from "./2021.vue?vue&type=template&id=b24917c6&"
import script from "./2021.vue?vue&type=script&lang=js&"
export * from "./2021.vue?vue&type=script&lang=js&"
import style0 from "./2021.vue?vue&type=style&index=0&id=b24917c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports